import cn from 'classnames';
import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';

const Text = ({
  brandStylesOverrides = '',
  className = '',
  htmlElement = 'p',
  children,
  ...restProps
}) => {
  const HtmlEl = htmlElement;
  const { brand } = useContext(BrandContext);

  return (
    <HtmlEl
      className={cn(className, brand, {
        ['text text-secondary']: !brandStylesOverrides,
        [brandStylesOverrides]: brandStylesOverrides,
      })}
      {...restProps}
    >
      {children}
    </HtmlEl>
  );
};

Text.propTypes = {
  htmlElement: PropTypes.oneOf(['p', 'span', 'dt', 'dd', 'dl', 'label']),
  className: PropTypes.string,
  brandStylesOverrides: PropTypes.string,
  children: PropTypes.node,
};

export default Text;
